// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"_1U2lfxdq6qAZ","active":"_3MRZ7qtz9OxV","selected":"_3I5dm--f_PDy"};